import type { TAnalyticsUse } from '../analytics.types';

export const ADOBE_LAUNCH_HISTORY_KEY = 'adobeLaunchHistory';

export const DEFAULT_USE: TAnalyticsUse[] = ['site', 'user', 'page'];

export const MOBILE_BREAKPOINT_PX = 768;

export const SITE_DEFAULTS = {
	domain: 'webmotors.com.br',
	country: 'brasil',
	server: 'web',
	environment: 'servicos',
	subEnvironment: 'garagem',
	tmsVersion: 'S32',
	clientType: 'pf',
	defaultBrandOrigin: 'webmotors',
} as const;
